<template>
    <b-container fluid>
        <b-row>
            <b-col class="text-center">
                <app-sub-title text="PQRs del equipo"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <!-- Filtros -->
                <app-petition-filters @filter="onFilter"></app-petition-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <!-- Tabla -->
                <app-data-table
                    :fields="fields"
                    :items="items"
                    :from="from"
                    :to="to"
                    :current-page="currentPage"
                    :total="total"
                    :per-page="perPage"
                    :last-page="lastPage"
                    :on-change-page="onChangePage"
                    @sort="onSort"
                >
                    <template v-slot:created_at="{ item }">
                        {{ item.created_at | datetime }}
                    </template>
                    <template v-slot:due_date="{ item }">
                        {{ item.due_date | datetime }}
                    </template>
                    <template v-slot:assigned_at="{ item }">
                        {{ item.assigned_at | datetime }}
                    </template>
                    <template v-slot:answer_date="{ item }">
                        {{ item.answer_date | datetime }}
                    </template>
                    <template v-slot:description="{ item }">
                        {{ item.description | elipsis(150) }}
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appPetitionFilters from '../PetitionsReview/PetitionsReviewFilters/PetitionsReviewFilters'
export default {
    components: {
        appPetitionFilters,
    },
    data: () => ({
        petitionsData: null,
        defaultStatus: 'asignada',
        page: 1,
        fields,
        sortCtx: null,
    }),
    computed: {
        items() {
            if (!this.petitionsData) return []

            return this.petitionsData.data.map(item => ({
                ...item,
                classes: !item.resolved && item.isOverdue ? 'overtime' : '',
            }))
        },
        currentPage() {
            if (!this.petitionsData) return 1

            return this.petitionsData.current_page
        },
        from() {
            if (!this.petitionsData) return 1

            return this.petitionsData.from
        },
        to() {
            if (!this.petitionsData) return 1

            return this.petitionsData.to
        },
        total() {
            if (!this.petitionsData) return 1

            return this.petitionsData.total
        },
        perPage() {
            if (!this.petitionsData) return 10

            return this.petitionsData.perPage
        },
        lastPage() {
            if (!this.petitionsData) return 1

            return this.petitionsData.last_page
        },
    },
    methods: {
        onSort(ctx) {
            this.page = 1
            this.sortCtx = ctx
            this.loadTeamPetitions()
        },
        onChangePage(page) {
            this.page = page
            this.loadTeamPetitions()
        },
        onFilter(filters) {
            this.page = 1
            this.loadTeamPetitions(filters)
        },
        async loadTeamPetitions(filters = null) {
            const params = {
                page: this.page,
                ...filters,
                ...this.sortCtx,
            }

            if (!filters || !filters.status) {
                params['statusSlug'] = this.defaultStatus
            }

            const { data } = await repo.get('petitions/team', params)
            this.petitionsData = data
        },
    },
    created() {
        this.loadTeamPetitions()
    },
}

const fields = [
    {
        key: 'id',
        label: 'ID',
    },
    {
        key: 'type_name',
        label: 'Tipo',
    },
    {
        key: 'status_name',
        label: 'Estado',
        orderBy: 'petition_statuses.name',
    },
    {
        key: 'petition_sub_category.petition_category.name',
        label: 'Categoría',
        orderBy: 'category',
    },
    {
        key: 'sub_category',
        label: 'Sub Categoría',
    },
    {
        key: 'client.name',
        label: 'Cliente',
    },
    {
        key: 'creator_name',
        label: 'Creador',
    },
    {
        key: 'description',
        label: 'Descripción',
    },
    {
        key: 'created_at',
        label: 'Fecha creación',
    },
    {
        key: 'due_date',
        label: 'Fecha vencimiento',
    },
    {
        key: 'overdue_days',
        label: 'días de vencimiento',
    },
    {
        key: 'assigned_at',
        label: 'Fecha asignación',
    },
    {
        key: 'answer_date',
        label: 'Fecha respuesta',
    },
    {
        key: 'assignee_name',
        label: 'Usuario asignado',
    },
    {
        key: 'approved_by_company_at',
        label: 'Fecha aprobación compañía',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
